<template>
    <img alt="Vue logo" src="https://www.kersthapjesbestellen.nl/img/logo-feedback-company.webp" class="logoImg" id="logo" style="width:100px; display:none;" />
    <img alt="Vue logo" src="https://www.kersthapjesbestellen.nl/img/logo-feedback-company.webp" class="logoImg" id="logoImg" style="width:100px; display:none;" />
  <div class="hello">
    <div style="border: 1px solid #c7ced4; padding: 1px; margin-bottom: 10px">
      <div v-if="stap == 1" class="bg-oranje" style="width: 16.3%; height: 28px; color:#fff;"></div>
      <div v-if="stap == 2" class="bg-oranje" style="width: 32.3%; height: 28px; color:#fff;"></div>
      <div v-if="stap == 3" class="bg-oranje" style="width: 48.3%; height: 28px; color:#fff;"></div>
      <div v-if="stap == 4" class="bg-oranje" style="width: 64.3%; height: 28px; color:#fff;"></div>
      <div v-if="stap == 5" class="bg-oranje" style="width: 80.3%; height: 28px; color:#fff;"></div>
      <div v-if="stap == 6" class="bg-oranje" style="width: 100%; height: 28px; color:#fff;"></div>
    </div>

    <div v-if="errors.length > 0" class="alert alert-danger">
        Er is een verplicht veld niet ingevuld, controleer het formulier.
    </div>

    <div class="row">
      <div class="col-12">
        <div v-if="stap == '1'">
          <h2>INSCHRIJFFORMULIER</h2>
          <div class="mb-3">
            <label
              for="exampleFormControlInput1"
              style="display: block"
              class="form-label"
              >Type
            </label>

          <select
              v-model="kamp_type"
              class="form-select"
              aria-label="Default select example"
              @change="changeType()"
            >
              <option v-for="type in types" :key="type.id" :value="type.id">
                {{ type.naam }}
              </option>
            </select>
            <Error field="kamp_type" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Locatie</label
            >
            <select
              v-model="kamp_locatie"
              class="form-select"
              aria-label="Default select example"
              @change="changeLocatie()"
            >
              <template v-for="locatie in locations" :key="locatie.id">
                <template v-for="val in locatie.types">
                  <option
                    v-if="val.id == kamp_type"
                    :key="val.id"
                    :value="locatie.id"
                  >
                    {{ locatie.naam }}
                  </option>
                </template>
              </template>
            </select>
            <Error field="kamp_locatie" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Kamp</label
            >
            <select
              v-model="kamp_date"
              class="form-select"
              aria-label="Default select example"
              @change="changeDate($event)"
            >
              <option
                v-for="date in dates"
                :key="date.id"
                :value="date.id"
                :prijs_deelnemer="date.prijs"
                :prijs_annu="date.annu"
              >
                {{ showDate2(date.start_datum) }} -
                {{ date.info }}
              </option>
            </select>
            <Error field="kamp_date" :errors="this.errors"></Error>
          </div>

          <div class="row">
            <div class="col align-self-end text-end">
              <button @click="volgendeStap" class="btn btn-dark">
                Volgende stap
              </button>
            </div>
          </div>
        </div>

        <div v-if="stap == '2'">
          <h2>GEGEVENS OUDERS/VERZORGERS</h2>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >VOORNAAM OUDERS/VERZORGERS</label
            >
            <input
              type="text"
              v-model="ouder_voornaam"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @blur="v$.ouder_voornaam.$touch"
              :class="{ 'is-invalid': v$.ouder_voornaam.$errors.length == '1' }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_voornaam.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
            <Error field="ouder_voornaam" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >ACHTERNAAM OUDERS/VERZORGERS</label
            >
            <input
              type="text"
              v-model="ouder_achternaam"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @blur="v$.ouder_achternaam.$touch"
              :class="{
                'is-invalid': v$.ouder_achternaam.$errors.length == '1',
              }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_achternaam.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
            <Error field="ouder_achternaam" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Postcode</label
            >
            <input
              type="text"
              v-model="ouder_postcode"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @change="getAdres()"
              @blur="v$.ouder_postcode.$touch"
              :class="{ 'is-invalid': v$.ouder_postcode.$errors.length == '1' }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_postcode.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
            <Error field="ouder_postcode" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Huisnummer</label
            >
            <input
              type="text"
              v-model="ouder_huisnummer"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @change="getAdres()"
              @blur="v$.ouder_huisnummer.$touch"
              :class="{
                'is-invalid': v$.ouder_huisnummer.$errors.length == '1',
              }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_huisnummer.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
            <Error field="ouder_huisnummer" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Straatnaam</label
            >
            <input
              type="text"
              v-model="ouder_straatnaam"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @blur="v$.ouder_straatnaam.$touch"
              :class="{
                'is-invalid': v$.ouder_straatnaam.$errors.length == '1',
              }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_straatnaam.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>

            <Error field="ouder_straatnaam" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Plaats</label
            >
            <input
              type="text"
              v-model="ouder_plaats"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @blur="v$.ouder_plaats.$touch"
              :class="{ 'is-invalid': v$.ouder_plaats.$errors.length == '1' }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_plaats.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
            <Error field="ouder_plaats" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Provincie</label
            >
            <select
              v-model="ouder_provincie"
              class="form-select"
              aria-label="Default select example"
            >
              <option
                v-for="provincie in provincies"
                :key="provincie.id"
                :value="provincie.id"
              >
                {{ provincie.naam }}
              </option>
            </select>
            <Error field="ouder_provincie" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Land</label
            >
            <select
              v-model="ouder_land"
              class="form-select"
              aria-label="Default select example"
            >
              <option
                v-for="land in landen"
                :key="land.id"
                :value="land.id"
                v-html="land.naam"
              ></option>
            </select>
            <Error field="ouder_land" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >E-mailadres</label
            >
            <input
              type="email"
              v-model="ouder_email"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @paste="disablePaste" @copy="disableCopy"
              @blur="v$.ouder_email.$touch"
              :class="{ 'is-invalid': v$.ouder_email.$errors.length == '1' }"
            />

            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_email.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>
            <Error field="ouder_email" :errors="this.errors"></Error>
          </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Herhaal e-mailadres</label
            >
            <input
              type="email"
              v-model="ouder_email_herhaal"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @paste="disablePaste" @copy="disableCopy"
              @blur="v$.ouder_email_herhaal.$touch"
              :class="{
                'is-invalid': v$.ouder_email_herhaal.$errors.length == '1',
              }"
            />

            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_email_herhaal.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>

            <Error field="ouder_email_herhaal" :errors="this.errors"></Error>
          </div>

           <div class="mb-3">

                <div
                  class="form-check"
                  v-for="option in deelnemeravg"
                  :key="option.id"
                >
                  <input
                    v-model="avg"
                    class="form-check-input"
                    type="checkbox"
                    :value="option.id"
                    :id="+option.id"
                  />
                  <label class="form-check-label" style="font-weight:normal; text-transform:lowercase; font-style:italic;" for="flexRadioDefault1">
                    {{ option.naam }}
                  </label>
                </div>
              </div>

          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Mobiel</label
            >
            <input
              type="tel" pattern="[0-9]*"
              v-model="ouder_mobiel"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder=""
              @blur="v$.ouder_mobiel.$touch"
              :class="{
                'is-invalid': v$.ouder_mobiel.$errors.length == '1',
              }"
            />
            <div
              class="input-errors"
              v-for="(error, index) of v$.ouder_mobiel.$errors"
              :key="index"
            >
              <div class="error-msg">{{ error.$message }}</div>
            </div>

            <Error field="ouder_mobiel" :errors="this.errors"></Error>
          </div>





          <div class="row">
            <div class="col align-self-start">
              <button @click="vorigeStap" class="btn btn-dark">
                Vorige stap
              </button>
            </div>

            <div class="col align-self-end text-end">
              <button @click="volgendeStap" class="btn btn-dark">
                Volgende stap
              </button>
            </div>
          </div>


        </div>

        <div v-if="stap == '3'">
          <h2>GEGEVENS DEELNEMER(S)</h2>
          <div v-for="(deelnemer, key) in deelnemers" :key="key">
            <div class="signup_kader mb-10">
              <h3>DEELNEMER #{{ deelnemer.id }}</h3>

              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Voornaam
                </label>
                <input
                  type="text"
                  v-model="deelnemer.voornaam"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-voornaam'"
                  :errors="this.errors"
                ></Error>
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Achternaam</label
                >
                <input
                  type="text"
                  v-model="deelnemer.achternaam"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-achternaam'"
                  :errors="this.errors"
                ></Error>
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Geslacht
                </label>

                <div
                  class="form-check form-check-inline ml-10"
                  v-for="option in genders"
                  :key="option.id"
                >
                  <input
                    v-model="deelnemer.geslacht"
                    class="form-check-input"
                    type="radio"
                    :value="option.id"
                    :id="'geslacht_'+ deelnemer.id + '-' + option.id"
                  />
                  <label class="form-check-label" :for="'geslacht_'+ deelnemer.id + '-' + option.id">
                    {{ option.naam }}
                  </label>
                </div>
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-geslacht'"
                  :errors="this.errors"
                ></Error>
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Geboortedatum</label
                >
                <input
                  type="date"
                  v-model="deelnemer.geboortedatum"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-geboortedatum'"
                  :errors="this.errors"
                ></Error>
              </div>



              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Vrienden
                  <button
                    type="button"
                    class="btn btn-sm btn-primary ml-15"
                    style="float: right; padding: 1px 5px; font-size: 10px"
                    data-bs-toggle="modal"
                    data-bs-target="#modal50"
                  >
                    meer info
                  </button></label
                >
                <input
                  type="text"
                  v-model="deelnemer.vrienden"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <p class="text-s mt-1">Geef max. 2 vrienden op met voor- en achternaam</p>
              </div>



              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Shirtmaat
                  <button
                    type="button"
                    class="btn btn-sm btn-primary ml-15"
                    style="float: right; padding: 1px 5px; font-size: 10px"
                    data-bs-toggle="modal"
                    data-bs-target="#modal46"
                  >
                    meer info
                  </button></label
                >

                <select v-model="deelnemer.shirtsize" class="form-select">
                  <option
                    v-for="shirt in shirts"
                    :key="shirt.id"
                    :value="shirt.id"
                  >
                    {{ shirt.naam }}
                  </option>
                </select>
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-shirtsize'"
                  :errors="this.errors"
                ></Error>
              </div>


<div >
              <hr class="mt-20 mb-20" />
              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Personaliseer jouw shirt
                  <button
                    type="button"
                    class="btn btn-sm btn-primary ml-15"
                    style="float: right; padding: 1px 5px; font-size: 10px"
                    data-bs-toggle="modal"
                    data-bs-target="#modal47"
                  >
                    meer info
                  </button></label
                >
                <div
                  class="form-check"
                  v-for="option in options"
                  :key="option.id"
                >

                  <div v-if="option.id != 8">
                  <input
                    v-model="deelnemer.option"
                    class="form-check-input"
                    type="radio"
                    :value="option.id"
                    @change="changeOption(option, deelnemer)"
                    :id="'sp_'+ deelnemer.id + '-' + option.id"
                  />
                  <label class="form-check-label" :for="'sp_'+ deelnemer.id + '-' + option.id">
                    {{ option.naam }}
                    <span v-if="option.prijs != '0.00'" class="signup-price"
                      >+ &euro; {{ option.prijs }}</span
                    >
                  </label>

                </div>

                <div v-if="option.id == 8 && this.kamp_date == 208">
                  <input
                    v-model="deelnemer.option"
                    class="form-check-input"
                    type="radio"
                    :value="option.id"
                    @change="changeOption(option, deelnemer)"
                    :id="'sp_'+ deelnemer.id + '-' + option.id"
                  />
                  <label class="form-check-label" :for="'sp_'+ deelnemer.id + '-' + option.id">
                    {{ option.naam }}
                    <span v-if="option.prijs != '0.00'" class="signup-price"
                      >+ &euro; {{ option.prijs }}</span
                    >
                  </label>

                </div>

                </div>


                                  <Error
                  :field="'deelnemer-' + deelnemer.id + '-option'"
                  :errors="this.errors"
                ></Error>
              </div>

              <div class="mb-3" v-if="deelnemer.naamopshirt_actief">
                <label for="exampleFormControlInput1" class="form-label"
                  >Naam op shirt (MAX 10 TEKENS)

                </label>
                <input
                  type="text"
                  v-model="deelnemer.naamopshirt"
                  maxlength="10"
                  class="form-control naamopshirt"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-naamopshirt'"
                  :errors="this.errors"
                ></Error>
              </div>

              <div class="mb-3" v-if="deelnemer.rugnummer_actief">
                <label for="exampleFormControlInput1" class="form-label"
                  >Rugnummer</label
                >

                <select
                  v-model="deelnemer.rugnummer"
                  class="form-select"
                  aria-label="Default select example"
                >
                  <option
                    v-for="(n, index) in 99"
                    :key="n"
                    :id="index"
                    :value="n"
                  >
                    {{ n }}
                  </option>
                </select>
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-rugnummer'"
                  :errors="this.errors"
                ></Error>
              </div>

</div>

              <hr class="mt-20 mb-20" />
              <div class="mb-3 d-none">
                <label for="exampleFormControlInput1" class="form-label"
                  >Dieet</label
                >
                <div class="form-check form-check-inline ml-10">
                  <input
                    v-model="deelnemer.dieet_actief"
                    class="form-check-input"
                    type="radio"
                    value="0"
                    :id="'dieet0_' + deelnemer.id"
                  />
                  <label class="form-check-label" :for="'dieet0_' + deelnemer.id">Nee</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    v-model="deelnemer.dieet_actief"
                    class="form-check-input"
                    type="radio"
                    value="1"
                    :id="'dieet1_' + deelnemer.id"
                  />
                  <label class="form-check-label" :for="'dieet1_' + deelnemer.id">Ja </label>

                </div>
              </div>

              <div class="mb-3" v-if="deelnemer.dieet_actief == '1'">
                <textarea
                  v-model="deelnemer.dieet"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                ></textarea>
              </div>

              <div class="mb-3 d-none">
                <label for="exampleFormControlInput1" class="form-label"
                  >Medicijnen / Allergie&euml;n
                </label>
                <div class="form-check form-check-inline ml-10">
                  <input
                    v-model="deelnemer.medicijnen_actief"
                    class="form-check-input"
                    type="radio"
                    value="0"
                    :id="'medi0_' + deelnemer.id"
                  />
                  <label class="form-check-label" :for="'medi0_' + deelnemer.id">Nee</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    v-model="deelnemer.medicijnen_actief"
                    class="form-check-input"
                    type="radio"
                    value="1"
                    :id="'medi1_' + deelnemer.id"
                  />
                  <label class="form-check-label" :for="'medi1_' + deelnemer.id">Ja </label>
                </div>
              </div>

              <div class="mb-3" v-if="deelnemer.medicijnen_actief == '1'">
                <textarea
                  v-model="deelnemer.medicijnen"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                ></textarea>
              </div>

              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Opmerkingen</label
                >
                <div class="form-check form-check-inline ml-10">
                  <input
                    v-model="deelnemer.opmerkingen_actief"
                    class="form-check-input"
                    type="radio"
                    value="0"
                    :id="'opmerking0_' + deelnemer.id"
                  />
                  <label class="form-check-label" :for="'opmerking0_' + deelnemer.id">Nee</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    v-model="deelnemer.opmerkingen_actief"
                    class="form-check-input"
                    type="radio"
                    value="1"
                    :id="'opmerking1_' + deelnemer.id"
                  />
                  <label class="form-check-label" :for="'opmerking1_' + deelnemer.id">Ja </label>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary ml-15"
                    style="padding: 1px 5px; font-size: 10px"
                    data-bs-toggle="modal"
                    data-bs-target="#modal48"
                  >
                    meer info
                  </button>
                </div>
              </div>

              <div class="mb-3" v-if="deelnemer.opmerkingen_actief == '1'">
                <textarea
                  v-model="deelnemer.opmerkingen"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                ></textarea>
              </div>

              <hr class="mb-20" />



              <div class="mb-3">
                <label for="exampleFormControlInput1" class="form-label"
                  >Privacy (AVG)
                  </label
                >
                <p class="text-s mt-0">
                  <em>Tijdens het jubileumkamp van ProCamp worden er de hele dag door
foto's en video-opnames gemaakt om de sfeer van het evenement vast te
leggen. Deze beelden kunnen worden gebruikt voor communicatiedoeleinden,
zoals onze website, social media, aftermovie en promotie van toekomstige
activiteiten. Vanwege de grootte van het kamp en het grote aantal
deelnemers is het voor ons helaas niet mogelijk om individuele verzoeken tot
het niet fotograferen van specifieke kinderen na te leven. </em>
                </p>

                <div
                  class="form-check"
                  v-for="option in deelnemerfoto"
                  :key="option.id"
                >
                  <input
                    v-model="deelnemer.foto"
                    class="form-check-input"
                    type="radio"
                    :value="option.id"
                    :id="'foto_'+ deelnemer.id + '-' + option.id"
                  />
                  <label class="form-check-label" :for="'foto_'+ deelnemer.id + '-' + option.id">
                    {{ option.naam }}
                  </label>
                </div>
                <Error
                  :field="'deelnemer-' + deelnemer.id + '-foto'"
                  :errors="this.errors"
                ></Error>
              </div>

              <div v-if="key != '0'">
                <button @click="deleteUser(key)" class="btn btn-sm btn-danger">
                  Verwijder deelnemer
                </button>
              </div>
            </div>
          </div>

          <div class="signup_kader mb-10">
            <p>
              Er zijn nu {{ this.aantal_deelnemers }} deelnemers.<br />
              <span
                v-for="d in deelnemers"
                :key="d.id"
                class="badge bg-dark mr-5"
              >
                {{ d.voornaam }}
              </span>
            </p>
            <button class="btn btn-lg btn-success mb-10" @click="addUser()">
              + Nog een deelnemer toevoegen
            </button>
          </div>

          <div class="row">
            <div class="col align-self-start">
              <button @click="vorigeStap" class="btn btn-dark">
                Vorige stap
              </button>
            </div>

            <div class="col align-self-end text-end">
              <button @click="volgendeStap" class="btn btn-dark">
                Volgende stap
              </button>
            </div>
          </div>
        </div>

        <div v-if="stap == '4'">
          <h3>ANNULERINGSVERZEKERING</h3>

          <div v-for="deelnemer in deelnemers" :key="deelnemer.id">
            <div class="mb-3 annu">
              <label
                for="exampleFormControlInput1"
                style="display: block"
                class="form-label"
                >Voor {{ deelnemer.voornaam }}
                <button
                  type="button"
                  class="btn btn-sm btn-primary ml-15"
                  style="float: right; padding: 1px 5px; font-size: 10px"
                  data-bs-toggle="modal"
                  data-bs-target="#modal45"
                >
                  meer info
                </button>
              </label>
              <div class="form-check">
                <input
                  v-model="deelnemer.annu"
                  class="form-check-input"
                  type="radio"
                  :value="1"
                  :id="'annu_'+ deelnemer.id + '-1'"
                />
                <label class="form-check-label" :for="'annu_'+ deelnemer.id + '-1'"
                  >JA,
                  <span style="text-transform: none; font-weight: normal"
                    >Ik wil een annuleringsverzekering zodat bij ziekte, blessures e.d. voorafgaand aan
de jubileumdag de kosten vergoed worden door ProCamp.</span
                  >
                  <span v-if="this.prijs_annu != '0.00'" class="signup-price"
                    ><br />+ {{ showPrice(this.prijs_annu) }}</span
                  >
                </label>
              </div>
              <div class="form-check">
                <input
                  v-model="deelnemer.annu"
                  class="form-check-input"
                  type="radio"
                  :value="0"
                  :id="'annu_'+ deelnemer.id + '-0'"
                />
                <label class="form-check-label" :for="'annu_'+ deelnemer.id + '-0'"
                  >NEE BEDANKT,
                  <span style="text-transform:none; font-weight: normal"
                    > Ik wil hier geen gebruik van maken. Ik begrijp dat als ik enige vorm
van dekking weiger, ik zelf verantwoordelijk ben voor annuleringskosten.</span
                  >
                </label>
              </div>
                          <Error
              :field="'deelnemer-' + deelnemer.id + '-annu'"
              :errors="this.errors"
            ></Error>
            </div>

          </div>

          <h3>OPTIONEEL</h3>

          <div v-for="deelnemer in deelnemers" :key="deelnemer.id">
            <div v-for="product in producten" :key="product.id">
              <div class="mb-3 product">
                <label
                  for="exampleFormControlInput1"
                  style="display: block"
                  class="form-label"
                  >{{ product.naam }} voor {{ deelnemer.voornaam }}
                  <button
                    type="button"
                    class="btn btn-sm btn-primary ml-15"
                    style="float: right; padding: 1px 5px; font-size: 10px"
                    data-bs-toggle="modal"
                    :data-bs-target="'#productmodal' + product.id"
                  >
                    meer info
                  </button></label
                >
                <p class="text-s mt-0">
                  <em>{{ product.omschrijving }}</em>
                </p>

                <div class="form-check form-check-inline ml-10">
                  <input
                    v-model="deelnemer.producten[product.id]"
                    class="form-check-input"
                    type="radio"
                    value="0"
                    :id="'product_'+ deelnemer.id + product.id +'-0'"
                  />
                  <label class="form-check-label" :for="'product_'+ deelnemer.id + product.id +'-0'">Nee</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    v-model="deelnemer.producten[product.id]"
                    class="form-check-input"
                    type="radio"
                    :value="product.id"
                    :id="'product_'+ deelnemer.id + product.id +'-1'"
                  />
                  <label class="form-check-label" :for="'product_'+ deelnemer.id + product.id +'-1'"
                    >Ja
                    <span  class="signup-price"
                      >+ {{ showPrice(product.prijs) }}</span
                    ></label
                  >
                </div>

                <div class="mb-3" v-if="product.id === 6 || product.id === 7">
                <label for="exampleFormControlInput1" class="form-label"
                  >NAAM OP SCHOENENTAS (MAX. 10 TEKENS)

                </label>
                <input
                  type="text"
                  v-model="deelnemer.extra1"
                  maxlength="10"
                  class="form-control naamopshirt"
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>

                <Error
                  :field="
                    'deelnemer-' + deelnemer.id + '-product-' + product.id + ''
                  "
                  :errors="this.errors"
                ></Error>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col align-self-start">
              <button @click="vorigeStap" class="btn btn-dark">
                Vorige stap
              </button>
            </div>

            <div class="col align-self-end text-end">
              <button @click="volgendeStap" class="btn btn-dark">
                Volgende stap
              </button>
            </div>
          </div>
        </div>

        <div v-if="stap == '5'">
          <h3>CONTROLEER INSCHRIJVING(EN)</h3>

          <div class="signup_kader mb-10">
            <strong
              >KAMPINFORMATIE
              <button
                @click="gaStap(1)"
                type="button"
                class="btn btn-sm btn-warning ml-15"
                style="float: right; padding: 1px 5px; font-size: 10px"
              >
                Aanpassen
              </button></strong
            ><br />

            <template v-for="val in types">
              <span v-if="val.id == kamp_type" :key="val.id"
                >{{ val.naam }}<br
              /></span>
            </template>

            <template v-for="val in locations">
              <span v-if="val.id == kamp_locatie" :key="val.id"
                >{{ val.naam }}<br
              /></span>
            </template>

            <template v-for="val in dates">
              <span v-if="val.id == kamp_date" :key="val.id"
                >{{ showDate2(val.start_datum) }} t/m
                {{ showDate2(val.eind_datum) }} <br
              /></span>
            </template>
          </div>

          <div class="signup_kader mb-10">
            <strong
              >OUDER/VERZORGER
              <button
                @click="gaStap(2)"
                type="button"
                class="btn btn-sm btn-warning ml-15"
                style="float: right; padding: 1px 5px; font-size: 10px"
              >
                Aanpassen
              </button></strong
            ><br />

            <div class="row" v-if="ouder_voornaam">
              <div class="col align-self-start">Naam:</div>
              <div class="col align-self-end text-end">
                {{ ouder_voornaam }} {{ ouder_achternaam }}
              </div>
            </div>

            <div class="row" v-if="ouder_straatnaam">
              <div class="col align-self-start">Adres:</div>
              <div class="col align-self-end text-end">
                {{ ouder_straatnaam }} {{ ouder_huisnummer }}
              </div>
            </div>

            <div class="row" v-if="ouder_postcode">
              <div class="col align-self-start">Naam:</div>
              <div class="col align-self-end text-end">
                {{ ouder_postcode }}
              </div>
            </div>

            <div class="row" v-if="ouder_plaats">
              <div class="col align-self-start">Plaats:</div>
              <div class="col align-self-end text-end">
                {{ ouder_plaats }}
              </div>
            </div>

            <div class="row" v-if="ouder_provincie">
              <div class="col align-self-start">Provincie:</div>
              <div class="col align-self-end text-end">
                <template v-for="a in provincies">
                  <span v-if="ouder_provincie == a.id" :key="a.id" class=""
                    >{{ a.naam }}<br
                  /></span>
                </template>
              </div>
            </div>

            <div class="row" v-if="ouder_land">
              <div class="col align-self-start">Land:</div>
              <div class="col align-self-end text-end">
                <template v-for="a in landen">
                  <span v-if="ouder_land == a.id" :key="a.id" class=""
                    >{{ a.naam }}<br
                  /></span>
                </template>
              </div>
            </div>

            <div class="row" v-if="ouder_email">
              <div class="col align-self-start">E-mail:</div>
              <div class="col align-self-end text-end">
                {{ ouder_email }}
              </div>
            </div>

            <div class="row" v-if="ouder_mobiel">
              <div class="col align-self-start">Mobiel:</div>
              <div class="col align-self-end text-end">
                {{ ouder_mobiel }}
              </div>
            </div>

            <div class="row" v-if="ouder_aanraking">
              <div class="col align-self-start">Aanraking met ProCamp:</div>
              <div class="col align-self-end text-end">
                <template v-for="a in aanraking">
                  <span v-if="ouder_aanraking == a.id" :key="a.id" class=""
                    >{{ a.naam }}<br
                  /></span>
                </template>
              </div>
            </div>
          </div>

          <div v-for="deelnemer in deelnemers" :key="deelnemer.id">
            <div class="signup_kader mb-10" v-if="deelnemer.voornaam">
              <span v-if="deelnemer.id"
                ><strong
                  >DEELNEMER #{{ deelnemer.id }}
                  <button
                    @click="gaStap(3)"
                    type="button"
                    class="btn btn-sm btn-warning ml-15"
                    style="float: right; padding: 1px 5px; font-size: 10px"
                  >
                    Aanpassen
                  </button></strong
                ><br
              /></span>

              <div class="row" v-if="deelnemer.voornaam">
                <div class="col align-self-start">Naam:</div>
                <div class="col align-self-end text-end">
                  {{ deelnemer.voornaam }} {{ deelnemer.achternaam }}
                </div>
              </div>

              <div class="row" v-if="deelnemer.geslacht">
                <div class="col align-self-start">Geslacht:</div>
                <div class="col align-self-end text-end">
                  <template v-for="option in genders">
                    <span
                      v-if="deelnemer.geslacht == option.id"
                      :key="option.id"
                    >
                      {{ option.naam }}
                    </span>
                  </template>
                </div>
              </div>

              <div class="row" v-if="deelnemer.geboortedatum">
                <div class="col align-self-start">Geboren:</div>
                <div class="col align-self-end text-end">
                  {{ showDate(deelnemer.geboortedatum) }}
                </div>
              </div>

              <div class="row" v-if="deelnemer.shirtsize">
                <div class="col align-self-start">Shirtmaat:</div>
                <div class="col align-self-end text-end">
                  <template v-for="shirt in shirts">
                    <span
                      v-if="deelnemer.shirtsize == shirt.id"
                      :key="shirt.id"
                    >
                      {{ shirt.naam }}
                    </span>
                  </template>
                </div>
              </div>

              <div class="row" v-if="deelnemer.socksize == '99999999'">
                <div class="col align-self-start">Sokken:</div>
                <div class="col align-self-end text-end">
                  <template v-for="sock in socks">
                    <span v-if="deelnemer.socksize == sock.id" :key="sock.id">
                      {{ sock.naam }}
                    </span>
                  </template>
                </div>
              </div>

              <div class="row" v-if="deelnemer.naamopshirt">
                <div class="col align-self-start">Naam op shirt:</div>
                <div class="col align-self-end text-end" style="text-transform:uppercase;">
                  {{ deelnemer.naamopshirt }}
                </div>
              </div>

              <div class="row" v-if="deelnemer.rugnummer">
                <div class="col align-self-start">Rugnummer:</div>
                <div class="col align-self-end text-end">
                  {{ deelnemer.rugnummer }}
                </div>
              </div>

              <div class="row" v-if="deelnemer.vrienden">
                <div class="col align-self-start">Vrienden:</div>
                <div class="col align-self-end text-end">
                  {{ deelnemer.vrienden }}
                </div>
              </div>

              <div class="row" v-if="deelnemer.hoeveeljaar == '99999'">
                <div class="col align-self-start">Hoeveelste keer:</div>
                <div class="col align-self-end text-end">
                  {{ deelnemer.hoeveeljaar }}e Jaar
                </div>
              </div>

              <div v-if="deelnemer.dieet_actief == '1'">
                Dieet:<br />
                <div class="signup_small">{{ deelnemer.dieet }}</div>
              </div>
              <div class="d-none" v-if="deelnemer.dieet_actief == '0'">Dieet: Nee<br /></div>
              <div v-if="deelnemer.medicijnen_actief == '99999999999'">
                Medicijnen / Allergie&euml;n: <br />
                <div class="signup_small">{{ deelnemer.medicijnen }}</div>
              </div>
              <div v-if="deelnemer.medicijnen_actief == '999999999'">
                Medicijnen / Allergie&euml;n: Nee<br />
              </div>

              <div v-if="deelnemer.opmerkingen_actief == '1'">
                Opmerkingen:<br />
                <div class="signup_small">{{ deelnemer.opmerkingen }}</div>
              </div>
              <div v-if="deelnemer.opmerkingen_actief == '0'">
                Opmerkingen: Nee<br />
              </div>

              <div class="row mb-10" v-if="deelnemer.avg">
                <div class="col align-self-start">
                  AVG:<br />
                  <template v-for="option in deelnemeravg">
                    <span
                      v-if="deelnemer.avg == option.id"
                      class="signup_small"
                      :key="option.id"
                    >
                      {{ option.naam }}
                    </span>
                  </template>
                </div>
              </div>

              <div class="row mb-10" v-if="deelnemer.foto">
                <div class="col align-self-start">
                  Fotobeleid:<br />
                  <template v-for="option in deelnemerfoto">
                    <span
                      v-if="deelnemer.foto == option.id"
                      class="signup_small"
                      :key="option.id"
                    >
                      {{ option.naam }}
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="signup_kader mb-10">
            <strong
              >EXTRA'S
              <button
                @click="gaStap(4)"
                type="button"
                class="btn btn-sm btn-warning ml-15"
                style="float: right; padding: 1px 5px; font-size: 10px"
              >
                Aanpassen
              </button></strong
            ><br />
            <div v-for="deelnemer in deelnemers" :key="deelnemer.id">
              <div v-if="deelnemer.annu == '1'">
                - Annuleringsverzekering voor {{ deelnemer.voornaam }}
              </div>

              <template v-for="p in deelnemer.producten">
                <template v-for="product in producten">
                  <div v-if="p == product.id" class="" :key="product.id">
                    - {{ product.naam }} voor {{ deelnemer.voornaam }}
                  </div>
                </template>
              </template>
            </div>
          </div>

          <div class="signup_kader mb-10">
            <strong>TOTAAL</strong><br />

            <div class="row">
              <div class="col align-self-start">
                {{ this.aantal_deelnemers }}x Kampkosten
              </div>
              <div class="col align-self-end text-end">
                &euro; {{ showPrice(aantal_deelnemers * this.prijs_deelnemer) }}
              </div>
            </div>

            <template v-for="d in deelnemers" :key="d.id">

                <div class="row">
                <div class="col align-self-start">
                  Boekingskosten {{ d.voornaam }}
                </div>
                <div class="col align-self-end text-end">
                  &euro; {{ showPrice(this.prijs_boekingskosten) }}
                </div>
              </div>

              <div class="row" v-if="d.annu == '1'" :key="d.id">
                <div class="col align-self-start">
                  Verzekering {{ d.voornaam }}
                </div>
                <div class="col align-self-end text-end">
                  &euro; {{ showPrice(this.prijs_annu) }}
                </div>
              </div>

              <template v-for="option in options">
                <div class="row" v-if="d.option == option.id">
                  <div class="col align-self-start">
                    Shirtbedrukking {{ d.voornaam }}<br />
                    <span class="signup_small" style="display: none">{{
                      option.naam
                    }}</span>
                  </div>
                  <div class="col align-self-end text-end">
                    &euro; {{ showPrice(option.prijs) }}
                  </div>
                </div>
              </template>

              <template v-for="p in d.producten">
                <template v-for="product in producten">
                  <div class="row" v-if="p == product.id" :key="product.id">
                    <div class="col align-self-start">
                      {{ product.naam }} {{ d.voornaam }}
                    </div>
                    <div class="col align-self-end text-end">
                      &euro; {{ showPrice(product.prijs) }}
                    </div>
                  </div>
                </template>
              </template>
            </template>

            <div v-if="this.aantal_deelnemers >= '2'">
              <div class="row">
                <div class="col align-self-start signup_term">
                  Gezinskorting
                </div>
                <div class="col align-self-end text-end signup_term">
                  &euro; -{{ showPrice((this.aantal_deelnemers - 1) * +this.deelnemerkorting) }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col align-self-start signup_totaal">Totaal</div>
              <div class="col align-self-end text-end signup_totaal">
                &euro; {{ showPrice(this.prijs_totaal) }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col align-self-start">
              <button @click="vorigeStap" class="btn btn-dark">
                Vorige stap
              </button>
            </div>

            <div class="col align-self-end text-end">
              <button @click="volgendeStap" class="btn btn-dark">
                Volgende stap
              </button>
            </div>
          </div>
        </div>

        <div v-if="stap == '6'">
          <div class="signup_kader mb-10 d-none">
            <label for="exampleFormControlInput1" class="form-label"
              >Heb je een kortingscode?
              <button
                type="button"
                class="btn btn-sm btn-primary ml-15"
                style="float: right; padding: 1px 5px; font-size: 10px"
                data-bs-toggle="modal"
                data-bs-target="#modal15"
              >
                meer info
              </button></label
            >
            <div class="row"  @mouseout="updateTotaal()">
              <div class="col-7">
                <input
                  type="text"
                  v-model="discount_id"
                  @change="postDiscount()"
                  @mouseout="updateTotaal()"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Kortingscode"
                />
              </div>
              <div class="col-5">
                <button class="btn col-12 btn-success" @click="postDiscount()"  @mouseout="updateTotaal()">
                  Toepassen
                </button>
              </div>
            </div>

            <div class="mt-2 mb-3" v-if="kamp_date == 208">

            <label for="exampleFormControlInput1" class="form-label"
              >Vul hieronder jouw stadspas nummer in.
            </label
            >
            <div class="row">
              <div class="col-7">
                <input
                  type="text"
                  v-model="stadspas"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Stadspas nummer"
                />
              </div>

            </div>

            <Error field="stadspas" :errors="this.errors"></Error>

        </div>

            <div v-if="discount != null">
              <p v-if="discount.length == '0'" class="discount-error">
                Deze code werkt niet (meer) of is reeds gebruikt.
              </p>
              <p v-if="discount.length == '1'" class="discount-success">
                De kortingscode is toegepast. Je ontvangt &euro;
                {{ showPrice(discount[0].bedrag) }} korting.
              </p>

            </div>
          </div>
          <div class="signup_kader mb-10">
            <label for="exampleFormControlInput1" class="form-label"
              >Kies een betaalmethode
              <button
                type="button"
                class="btn btn-sm btn-primary ml-15"
                style="float: right; padding: 1px 5px; font-size: 10px"
                data-bs-toggle="modal"
                data-bs-target="#modal49"
              >
                meer info
              </button></label
            >
            <div
              class="form-check"
              v-for="betaalmethode in betaalmethodes"
              :key="betaalmethode.id"
            >
              <input
                v-model="payment_id"
                class="form-check-input"
                type="radio"
                @change="updateTotaal()"
                :value="betaalmethode.id"
                :id="'betaalmethode_'+betaalmethode.id"
              />
              <label class="form-check-label" :for="'betaalmethode_'+betaalmethode.id">
                {{ betaalmethode.naam }}
                <span v-if="betaalmethode.ammount != null" class="signup-price"
                  >+ &euro; {{ showPrice(betaalmethode.ammount) }}</span
                >
              </label>
            </div>
            <Error field="payment_id" :errors="this.errors"></Error>
          </div>

          <div class="signup_kader mb-10">
            <div class="row">
              <div class="col align-self-start signup_term">Subtotaal</div>
              <div class="col align-self-end text-end signup_term">
                &euro; {{ showPrice(this.prijs_subtotaal) }}
              </div>
            </div>

            <div class="row" v-if="this.prijs_administratiekosten != '0'">
              <div class="col align-self-start signup_term">
                Administratiekosten
              </div>
              <div class="col align-self-end text-end signup_term">
                &euro; {{ showPrice(this.prijs_administratiekosten) }}
              </div>
            </div>

            <div v-if="discount != null">
              <div class="row" v-if="discount.length == '1'">
                <div class="col align-self-start signup_term">Korting</div>
                <div class="col align-self-end text-end signup_term">
                  &euro; -{{ showPrice(discount[0].bedrag) }}
                </div>
              </div>
            </div>

            <div v-if="this.aantal_deelnemers >= '2'">
              <div class="row">
                <div class="col align-self-start signup_term">
                  Gezinskorting
                </div>
                <div class="col align-self-end text-end signup_term">
                  &euro; -{{ showPrice((this.aantal_deelnemers - 1) * +this.deelnemerkorting) }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col align-self-start signup_totaal">Totaal</div>
              <div class="col align-self-end text-end signup_totaal">
                &euro; {{ showPrice(this.prijs_totaal) }}
              </div>
            </div>

            <div class="row" v-if="payment_id == '3'">
              <div class="col align-self-start signup_term">
                Aanbetaling (25%)
              </div>
              <div class="col align-self-end text-end signup_term">
                &euro; {{ showPrice(this.prijs_totaal25) }}
              </div>
            </div>

            <div class="row" v-if="payment_id == '3'">
              <div class="col align-self-start signup_term">Restant</div>
              <div class="col align-self-end text-end signup_term">
                &euro; {{ showPrice(this.prijs_totaal75) }}
              </div>
            </div>
          </div>

          <div class="signup_kader mb-10">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="akkoord_voorwaarden"
                id="akkoord_voorwaarden"
                :true-value="1"
                :false-value="0"
              />
              <label class="form-check-label" for="akkoord_voorwaarden">
                Ik accepteer de
                <a
                  target="_blank"
                  href="https://www.procamp.nl/c-26-algemene-voorwaarden.html"
                  >algemene voorwaarden</a
                >.
              </label>
            </div>
            <Error field="akkoord_voorwaarden" :errors="this.errors"></Error>
          </div>

          <div class="row">
            <div class="col align-self-start">
              <button @click="vorigeStap" class="btn btn-dark">
                Vorige stap
              </button>
            </div>

            <div class="col align-self-end text-end">
              <button @click="inschrijven" class="btn btn-success">
                Inschrijven
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-for="product in producten" :key="product.id">
    <template v-if="product.modal_item">
      <Modal
        :id="'productmodal' + product.id"
        :title="product.modal_item.titel"
        :content="product.modal_item?.content"
      ></Modal>
    </template>
  </div>

  <div v-for="modal in modals" :key="modal.id">
    <Modal
      :id="'modal' + modal.id"
      :title="modal?.titel"
      :content="modal?.content"
      >{{ modal?.content }}</Modal
    >
  </div>
</template>

<script>
import Error from "./Error.vue";
import Modal from "./Modal.vue";

import useVuelidate from "@vuelidate/core";
import {
  required,
  email,
  numeric,
  helpers,
  sameAs,
} from "@vuelidate/validators";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    Error,
    Modal,
  },
  name: "SignUp",
  data() {
    return {
      stap: 1,
      errors: [],
      message: null,
      kamp_type: 3,
      kamp_locatie: 36,
      kamp_date: null,
      dates: null,
      locations: null,
      types: null,
      settings: null,
      avg: true,
      deelnemerkorting: 0,
      ouder_voornaam: null,
      ouder_achternaam: null,
      ouder_straatnaam: null,
      ouder_huisnummer: null,
      ouder_postcode: null,
      ouder_plaats: null,
      ouder_provincie: null,
      ouder_land: "140",
      ouder_email: null,
      ouder_email_herhaal: null,
      ouder_mobiel: null,
      ouder_aanraking: null,
      aantal_deelnemers: 1,
      current_deelnemer: 1,
      stadspas: null,
      payment_id: null,
      discount_id: null,
      discount: null,
      aanraking: null,
      betaalmethodes: null,
      clubs: null,
      deelnemeravg: null,
      deelnemerfoto: null,
      genders: null,
      landen: null,
      modalmodals: null,
      options: null,
      producten: null,
      provincies: null,
      socks: null,
      shirts: null,
      searchLandTerm: "",
      searchClubTerm: "",
      aantal_dagen: "",
      akkoord_voorwaarden: null,
      prijs_deelnemer: null,
      prijs_annu: null,
      prijs_option: null,
      prijs_subtotaal: 0,
      prijs_boekingskosten: 0,
      prijs_administratiekosten: 0,
      prijs_totaal: 0,
      prijs_totaal25: 0,
      prijs_totaal75: 0,
      deelnemers: [
        {
          id: "1",
          geslacht: null,
          voornaam: null,
          achternaam: null,
          geboortedatum: null,
          dieet: null,
          dieet_actief: null,
          medicijnen: null,
          medicijnen_actief: null,
          opmerkingen: null,
          opmerkingen_actief: null,
          hoeveeljaar: null,
          vrienden: null,
          voetbalclub: null,
          option: null,
          rugnummer: null,
          naamopshirt: null,
          rugnummer_actief: null,
          naamopshirt_actief: null,
          shirtsize: null,
          socksize: null,
          annu: null,
          avg: null,
          foto: null,
          extra1: null,
          producten: [],
        },
      ],
    };
  },
  props: {
    msg: String,
  },

  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    var type_id = urlParams.get("type_id");
    var location_id = urlParams.get("location_id");
    var camp_id = urlParams.get("camp_id");

    if (type_id != null) {
      this.kamp_type = type_id;
    }

    if (location_id != null) {
      this.kamp_locatie = location_id;
      this.changeLocatie();
    }

    if (camp_id != null) {
      //this.kamp_date = camp_id;
    }

    this.axios
      .get("https://www.procamp.nl/json/aanraking")
      .then((response) => (this.aanraking = response.data))
      .catch((error) => (this.aanraking = error));

    this.axios
      .get("https://www.procamp.nl/json/betaalmethode")
      .then((response) => (this.betaalmethodes = response.data))
      .catch((error) => (this.betaalmethodes = error));

    this.axios
      .get("https://www.procamp.nl/json/clubs")
      .then((response) => (this.clubs = response.data))
      .catch((error) => (this.clubs = error));

    this.axios
      .get("https://www.procamp.nl/json/deelnemeravg")
      .then((response) => (this.deelnemeravg = response.data))
      .catch((error) => (this.deelnemeravg = error));

    this.axios
      .get("https://www.procamp.nl/json/deelnemerfoto")
      .then((response) => (this.deelnemerfoto = response.data))
      .catch((error) => (this.deelnemerfoto = error));

    this.axios
      .get("https://www.procamp.nl/json/genders")
      .then((response) => (this.genders = response.data))
      .catch((error) => (this.genders = error));

    this.axios
      .get("https://www.procamp.nl/json/landen")
      .then((response) => (this.landen = response.data))
      .catch((error) => (this.landen = error));

    this.axios
      .get("https://www.procamp.nl/json/locationsverjaardag")
      .then((response) => (this.locations = response.data))
      .catch((error) => (this.locations = error));

    this.axios
      .get("https://www.procamp.nl/json/optionsverjaardag")
      .then((response) => (this.options = response.data))
      .catch((error) => (this.options = error));

    this.axios
      .get("https://www.procamp.nl/json/modals")
      .then((response) => (this.modals = response.data))
      .catch((error) => (this.modals = error));

    this.axios
      .get("https://www.procamp.nl/json/producten")
      .then((response) => (this.producten = response.data))
      .catch((error) => (this.producten = error));

    this.axios
      .get("https://www.procamp.nl/json/provincies")
      .then((response) => (this.provincies = response.data))
      .catch((error) => (this.provincies = error));

    this.axios
      .get("https://www.procamp.nl/json/shirts")
      .then((response) => (this.shirts = response.data))
      .catch((error) => (this.shirts = error));

    this.axios
      .get("https://www.procamp.nl/json/socks")
      .then((response) => (this.socks = response.data))
      .catch((error) => (this.socks = error));

    this.axios
      .get("https://www.procamp.nl/json/settings")
      .then((response) => (this.settings = response.data))
      .catch((error) => (this.settings = error));

    this.axios
      .get("https://www.procamp.nl/json/typesverjaardag")
      .then((response) => (this.types = response.data))
      .catch((error) => (this.types = error));
  },

  methods: {
    disablePaste(event) {
        event.preventDefault();
    },
    disableCopy(event) {
        event.preventDefault();
    },
    setAdres(response) {
      this.ouder_straatnaam = response.data.street;
      this.ouder_plaats = response.data.settlement;

      var provincies = this.provincies;

      provincies.forEach((element) => {
        if (element.naam == response.data.province) {
          this.ouder_provincie = element.id;
        }
      });
    },
    getAdres() {
      this.axios
        .get("https://api.pro6pp.nl/v2/autocomplete/nl", {
          params: {
            authKey: "kRNrlFTZRegtKPZf",
            postalCode: this.ouder_postcode,
            streetNumber: this.ouder_huisnummer,
          },
        })
        .then((response) => this.setAdres(response))
        .catch((error) => console.log(error));
    },
    postDiscount() {
      this.axios
        .get("https://www.procamp.nl/json/discount", {
          params: {
            discount_id: this.discount_id,
          },
        })
        .then((response) => (this.discount = response.data))
        .catch((error) => (this.discount = error));
    },
    updateTotaal() {
      var totaal = 0;

      //Deelnemers
      var deelnemers = this.deelnemers;

      deelnemers.forEach((element) => {
        //kampkosten
        console.log(totaal + "+" + this.prijs_deelnemer);
        totaal = +totaal + +this.prijs_deelnemer;

        //Boekingskosten
        totaal = +totaal + +this.prijs_boekingskosten;

        //Annuleringverzekering
        if (element.annu == "1") {
          totaal = +totaal + +this.prijs_annu;
        }

        //Personaliseer shirt
        this.options.forEach((e) => {
          if (element.option == e.id) {
            totaal = +totaal + +e.prijs;
          }
        });

        //Extras
        this.producten.forEach((e) => {
          if (element.producten[e.id] == e.id) {
            totaal = +totaal + +e.prijs;
          }
        });
      });

      //Subtotaal
      this.prijs_subtotaal = totaal;

      //Extras
      this.betaalmethodes.forEach((e) => {
        if (this.payment_id == e.id) {
          this.prijs_administratiekosten = 0;
          if (e.ammount != null) {
            totaal = +totaal + +e.ammount;
            this.prijs_administratiekosten = +e.ammount;
          }
        }
      });

      //Discount
      if (this.discount != null) {
        if (this.discount.id != "0" && this.discount.length != "0") {
          totaal = +totaal - +this.discount[0].bedrag;
        }
      }

      //Deelnemers korting
      if (this.aantal_deelnemers >= "2") {
        totaal = +totaal - (this.aantal_deelnemers - 1) * this.deelnemerkorting;
      }

      this.prijs_totaal = totaal;
      this.prijs_totaal25 = totaal * 0.25;
      this.prijs_totaal75 = totaal * 0.75;
    },

    showDate(date) {
      var dArr = date.split("-"); // ex input "2010-01-18"
      return dArr[2] + "/" + dArr[1] + "/" + dArr[0];
    },
    showDate2(date) {
      var dArr1 = date.split("T"); // ex input "2010-01-18"
      var dArr2 = dArr1[0].split("-"); // ex input "2010-01-18"
      return dArr2[2] + "/" + dArr2[1] + "/" + dArr2[0];
    },
    showPrice(price) {
      var nf = new Intl.NumberFormat("nl-NL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      var prijs = nf.format(price);
      return prijs;
    },
    changeDate(event) {
      this.prijs_deelnemer = event.target[event.target.selectedIndex].attributes.prijs_deelnemer.value;
      this.prijs_boekingskosten = 0;
      this.prijs_annu = event.target[event.target.selectedIndex].attributes.prijs_annu.value ?? 0;
      this.deelnemerkorting = 0;
      this.aantal_dagen = 30;
    },
    changeType() {
      this.kamp_locatie = "";
      this.kamp_date = "";
    },
    changeLocatie() {
      this.kamp_date = "";
      this.axios
        .get("https://www.procamp.nl/json/dates", {
          params: {
            type_id: this.kamp_type,
            location_id: this.kamp_locatie,
          },
        })
        .then((response) => (this.dates = response.data))
        .catch((error) => (this.dates = error));
    },
    changeOption(option, deelnemer) {
      if (option.option_naamopshirt == "1") {
        deelnemer.naamopshirt_actief = 1;
      } else {
        deelnemer.naamopshirt_actief = 0;
      }

      if (option.option_rugnummer == "1") {
        deelnemer.rugnummer_actief = 1;
      } else {
        deelnemer.rugnummer_actief = 0;
      }

      if (option.option_naamopshirt == "1") {
        //deelnemer.rugnummer_actief = 1;
      } else {
        deelnemer.naamopshirt = '';
      }


      if (option.option_vastrugnummer == "1") {
        deelnemer.rugnummer = 20;
      } else {
        deelnemer.rugnummer = null;
      }

      //this.updateTotaal();
    },
    deleteUser(id) {
      this.deelnemers.splice(id, 1);
      this.aantal_deelnemers = this.aantal_deelnemers - 1;
    },

    addUser() {
      this.aantal_deelnemers = this.aantal_deelnemers + 1;
      var id = this.aantal_deelnemers;

      //console.log(id);

      this.deelnemers.push({
        id: +id,
        geslacht: null,
        voornaam: null,
        achternaam: null,
        geboortedatum: null,
        dieet: null,
        dieet_actief: 0,
        medicijnen: null,
        medicijnen_actief: 0,
        opmerkingen: null,
        opmerkingen_actief: 0,
        hoeveeljaar: null,
        vrienden: null,
        voetbalclub: null,
        option: null,
        rugnummer: null,
        naamopshirt: null,
        rugnummer_actief: 0,
        naamopshirt_actief: 0,
        shirtsize: null,
        socksize: null,
        annu: null,
        avg: null,
        foto: null,
        extra1: null,
        producten: [],
      });

      console.log(this.user);
    },

    gaStap(stap) {
      var error = "";
      //stap 2
      if (
        stap == 2 &&
        (this.ouder_voornaam == "" ||
          this.ouder_achternaam == "" ||
          this.ouder_straatnaam == "" ||
          this.ouder_huisnummer == "" ||
          this.ouder_postcode == "" ||
          this.ouder_provincie == "" ||
          this.ouder_land == "" ||
          this.ouder_email == "" ||
          this.ouder_email_herhaal == "" ||
          this.ouder_mobiel == "" ||
          this.ouder_aanraking == "" ||
          this.ouder_voornaam == null)
      ) {
        error = error + "Graag eerst stap 2 invullen.";
      }
      if (error == "") {
        this.stap = stap;
      } else {
        alert(error);
      }
      //stap 1

      if (
        stap == 1 &&
        (this.kamp_type == "" ||
          this.kamp_locatie == "" ||
          this.kamp_date == "" ||
          this.kamp_date == null)
      ) {
        error = error + "Graag eerst stap 1 invullen.";
      }
      if (error == "") {
        this.stap = stap;
      } else {
        alert(error);
      }
    },

    inschrijven() {
      this.errors = [];

      if (this.kamp_date == 97 && this.stadspas == null) {
        this.errors.push({
          field: "stadspas",
          msg: "Je moet een stadspas nummer opgeven.",
        });
      }

      if (this.payment_id == "" || this.payment_id == null) {
        this.errors.push({
          field: "payment_id",
          msg: "Je moet een betaalmethode selecteren.",
        });
      }

      if (
        this.akkoord_voorwaarden == "" ||
        this.akkoord_voorwaarden == null ||
        this.akkoord_voorwaarden == "0"
      ) {
        this.errors.push({
          field: "akkoord_voorwaarden",
          msg: "Je moet akkoord gaan met onze voorwaarden.",
        });
      }

      if (this.errors.length == "0") {
        // Post de aanmelding
        this.axios
          .post("https://www.procamp.nl/json/inschrijvenverjaardag", {
            params: {
              avg: this.avg,
              kamp_type: this.kamp_type,
              kamp_locatie: this.kamp_locatie,
              kamp_date: this.kamp_date,
              ouder_voornaam: this.ouder_voornaam,
              ouder_achternaam: this.ouder_achternaam,
              ouder_straatnaam: this.ouder_straatnaam,
              ouder_huisnummer: this.ouder_huisnummer,
              ouder_postcode: this.ouder_postcode,
              ouder_plaats: this.ouder_plaats,
              ouder_provincie: this.ouder_provincie,
              ouder_land: this.ouder_land,
              ouder_email: this.ouder_email,
              ouder_email_herhaal: this.ouder_email_herhaal,
              ouder_mobiel: this.ouder_mobiel,
              ouder_aanraking: this.ouder_aanraking,
              aantal_deelnemers: this.aantal_deelnemers,
              stadspas: this.stadspas,
              payment_id: this.payment_id,
              discount_id: this.discount_id,
              akkoord_voorwaarden: this.akkoord_voorwaarden,
              deelnemers: this.deelnemers,
            },
          })
          .then(
            (response) => {
              if (response.data.status == "1") {
                document.location = response.data.url;
              } else {
                alert("er gaat iets mis, probeer het nogmaals");
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        alert('Er gaat iets mis, controleer de inschrijving of neem contact op met de helpdesk.');
      }
    },

    scrollToTop() {
      //window.scrollTo(0, 0);
    },

    volgendeStap() {
      this.updateTotaal();

      this.scrollToTop();

      var stap = this.stap;
      //var error = "";

      //stap 5
      if (stap == 5) {
        this.errors = [];

        if (this.errors.length == "0") {
          this.stap = this.stap + 1;
        } else {
          alert('Er gaat iets mis, controleer de inschrijving of neem contact op met de helpdesk.');
        }
      }

      //stap 4
      if (stap == 4) {
        this.errors = [];

        var deelnemers = this.deelnemers;

        deelnemers.forEach((element) => {
          if (element.annu != "0" && element.annu != "1") {
            this.errors.push({
              field: "deelnemer-" + element.id + "-annu",
              msg: "Dit is een verplicht veld.",
            });
          }
        });

        if (this.errors.length == "0") {
          this.stap = this.stap + 1;
        } else {
          //alert(error);
        }
      }

      //stap 3
      if (stap == 3) {
        this.errors = [];

        var deelnemers2 = this.deelnemers;

        deelnemers2.forEach((element) => {
        if (element.option == "" || element.option == null) {

            if(this.aantal_dagen <= 20)
            {
                element.option = 1;
            }
            if(this.aantal_dagen >= 21)
            {
            this.errors.push({
              field: "deelnemer-" + element.id + "-option",
              msg: "Dit is een verplicht veld.",
            });
            }
          }

        if (element.naamopshirt_actief == "1")
        {
           if (element.naamopshirt == "" || element.naamopshirt == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-naamopshirt",
              msg: "Dit is een verplicht veld.",
            });
          }
        }

        if (element.rugnummer_actief == "1")
        {
           if (element.rugnummer == "" || element.rugnummer == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-rugnummer",
              msg: "Dit is een verplicht veld.",
            });
          }
        }


          if (element.geslacht == "" || element.geslacht == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-geslacht",
              msg: "Dit is een verplicht veld.",
            });
          }
          if (element.voornaam == "" || element.voornaam == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-voornaam",
              msg: "Dit is een verplicht veld",
            });
          }
          if (element.achternaam == "" || element.achternaam == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-achternaam",
              msg: "Dit is een verplicht veld",
            });
          }
          if (element.geboortedatum == "" || element.geboortedatum == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-geboortedatum",
              msg: "Dit is een verplicht veld",
            });
          }
          if (element.shirtsize == "" || element.shirtsize == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-shirtsize",
              msg: "Dit is een verplicht veld",
            });
          }

          if (element.foto == "" || element.foto == null) {
            this.errors.push({
              field: "deelnemer-" + element.id + "-foto",
              msg: "Dit is een verplicht veld",
            });
          }
        });

        if (this.errors.length == "0") {
          this.stap = this.stap + 1;
        } else {
          //alert(error);
        }
      }

      //stap 2
      if (stap == 2) {
        this.errors = [];

        if (this.ouder_voornaam == "" || this.ouder_voornaam == null) {
          this.errors.push({
            field: "ouder_voornaam",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_achternaam == "" || this.ouder_achternaam == null) {
          this.errors.push({
            field: "ouder_achternaam",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_straatnaam == "" || this.ouder_straatnaam == null) {
          this.errors.push({
            field: "ouder_straatnaam",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_huisnummer == "" || this.ouder_huisnummer == null) {
          this.errors.push({
            field: "ouder_huisnummer",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_postcode == "" || this.ouder_postcode == null) {
          this.errors.push({
            field: "ouder_postcode",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_provincie == "" || this.ouder_provincie == null) {
          this.errors.push({
            field: "ouder_provincie",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_land == "" || this.ouder_land == null) {
          this.errors.push({
            field: "ouder_land",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_email == "" || this.ouder_email == null) {
          this.errors.push({
            field: "ouder_email",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (
          this.ouder_email_herhaal == "" ||
          this.ouder_email_herhaal == null
        ) {
          this.errors.push({
            field: "ouder_email_herhaal",
            msg: "Je moet dit veld invullen.",
          });
        }
        if (this.ouder_mobiel == "" || this.ouder_mobiel == null) {
          this.errors.push({
            field: "ouder_mobiel",
            msg: "Je moet dit veld invullen.",
          });
        }


        if (this.errors.length == "0") {
          this.stap = this.stap + 1;
        } else {
          //alert(error);
        }
      }

      //Stap 1
      if (stap == 1) {
        this.errors = [];

        if (this.kamp_type == "" || this.kamp_type == null) {
          this.errors.push({
            field: "kamp_type",
            msg: "Je moet een kamp selecteren.",
          });
        }
        if (this.kamp_locatie == "" || this.kamp_locatie == null) {
          this.errors.push({
            field: "kamp_locatie",
            msg: "Je moet een locatie selecteren.",
          });
        }
        if (this.kamp_date == "" || this.kamp_date == null) {
          this.errors.push({
            field: "kamp_date",
            msg: "Je moet een datum selecteren.",
          });
        }

        if (this.errors.length == "0") {
          this.stap = this.stap + 1;
        } else {
          //alert(error);
        }
      }
    },

    vorigeStap() {
      this.stap = this.stap - 1;
      this.scrollToTop();
    },
  },

  validations() {
    return {
      ouder_voornaam: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
      },
      ouder_achternaam: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
      },
      ouder_straatnaam: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
      },
      ouder_huisnummer: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
      },
      ouder_postcode: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
      },
      ouder_plaats: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
      },
      ouder_email: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
        email: helpers.withMessage("Dit is geen geldig e-mailadres.", email),
      },
      ouder_email_herhaal: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
        email: helpers.withMessage(
          "Je moet een geldig e-mailadres invullen.",
          email
        ),
        sameAs: helpers.withMessage(
          "Beide e-mailadressen zijn niet identiek.",
          sameAs(this.ouder_email)
        ),
      },
      ouder_mobiel: {
        required: helpers.withMessage("Dit is een verplicht veld.", required),
        numeric: helpers.withMessage(
          "U kunt alleen nummers invullen.",
          numeric
        ),
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}

.discount-error {
  font-size: 11px;
  color: red;
}

.discount-success {
  font-size: 11px;
  color: green;
}

.signup-price {
  font-size: 11px;
  color: green;
}

.error-msg {
  color: darkred;
  font-size: 13px;
}

.annu {
  border: 1px solid #f0f0f0;
  padding: 10px;
  border-radius: 10px;
}

.product {
  border: 1px solid #f0f0f0;
  padding: 10px;
  border-radius: 10px;
}

.product_meer info {
  font-size: 13px;
  color: grey;
  margin-bottom: 15px;
}

.signup_kader {
  border: 1px solid #f0f0f0;
  padding: 10px;
  border-radius: 10px;
}

.signup_small {
  color: blueviolet;
  font-size: 12px !important;
  margin-bottom: 10px;
}

.signup_totaal {
  color: green;
  font-weight: 700;
}

.naamopshirt {
    text-transform: uppercase;
}
</style>
